<template>

  <div>

    <el-form :inline="true" :model="query" @keyup.enter.native="load">

      <el-form-item label="内部单号"><el-input v-model="query.code" size="small" clearable /></el-form-item>

      <el-form-item label="供应商"><el-input v-model="query.partnerName" size="small" clearable /></el-form-item>

      <el-form-item label="审核">

        <el-select v-model="query.approveStatus" clearable size="small" style="width:100px">

          <el-option label="未审核" value="0" /><el-option label="已审核" value="2" />

        </el-select>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('finance:invoicePurchase:list')" type="primary" size="small" @click="load">查询</el-button>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('finance:invoicePurchase:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>

      </el-form-item>

    </el-form>

    <el-table :data="shown" border v-loading="loading" :header-cell-style="headStyle">

      <el-table-column type="index" label="序号" width="60" align="center" />

      <el-table-column prop="code" label="内部单号" width="160">

        <template slot-scope="scope">

          <a v-if="isAuth('finance:invoicePurchase:info')" class="code-link" @click="addOrUpdateHandle(scope.row.id, true)">{{ scope.row.code }}</a>

          <span v-else>{{ scope.row.code }}</span>

        </template>

      </el-table-column>

      <el-table-column prop="taxInvoiceNumber" label="税务发票号码" min-width="160" show-overflow-tooltip />
      <el-table-column prop="bizDate" label="发票日期" width="120" align="center" />

      <el-table-column prop="partnerName" label="供应商" min-width="150" />

      <el-table-column prop="amount" label="金额" width="120" align="right">

        <template slot-scope="scope">{{ money(scope.row.amount) }}</template>

      </el-table-column>

      <el-table-column prop="approveStatus" label="状态" width="90" align="center">

        <template slot-scope="scope">

          <el-tag v-if="scope.row.approveStatus === '2'" type="success" size="small">已审核</el-tag>

          <el-tag v-else type="info" size="small">未审核</el-tag>

        </template>

      </el-table-column>

      <el-table-column label="操作" width="140" align="center">

        <template slot-scope="scope">

          <el-button v-if="isAuth('finance:invoicePurchase:approve') && scope.row.approveStatus !== '2'" type="text" size="small" @click="approve(scope.row, true)">审核</el-button>

          <el-button v-if="isAuth('finance:invoicePurchase:unapprove') && scope.row.approveStatus === '2'" type="text" size="small" @click="approve(scope.row, false)">弃审</el-button>

        </template>

      </el-table-column>

    </el-table>

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />

  </div>

</template>



<script>

import AddOrUpdate from './invoice-purchase-add-or-update'

import request from '../../api/request'

import auth from './financeAuth'



export default {

  name: 'InvoicePurchase',

  mixins: [auth],

  components: { AddOrUpdate },

  data() {

    return {

      query: { code: '', partnerName: '', approveStatus: '' },

      list: [],

      addOrUpdateVisible: false

    }

  },

  computed: {

    shown() {

      return this.list.filter(row => {

        if (this.query.code && String(row.code || '').indexOf(this.query.code) < 0) return false

        if (this.query.partnerName && String(row.partnerName || '').indexOf(this.query.partnerName) < 0) return false

        if (this.query.approveStatus && String(row.approveStatus) !== this.query.approveStatus) return false

        return true

      })

    }

  },

  created() { this.load() },

  methods: {

    load() {

      this.loading = true

      request.get('/finance/doc/list', { params: { kind: 'invoicePurchase' } }).then(res => { this.list = res.data || [] }).finally(() => { this.loading = false })

    },

    addOrUpdateHandle(id, readonly) {

      this.addOrUpdateVisible = true

      this.$nextTick(() => {

        this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, readonly)

      })

    },
    open(id, readonly) { this.addOrUpdateHandle(id, !!readonly) },

    approve(row, pass) {

      const url = pass ? '/finance/doc/approve' : '/finance/doc/unapprove'

      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {

        request.post(url, { kind: 'invoicePurchase', id: row.id }).then(() => {

          this.$message.success(pass ? '审核成功' : '弃审成功')

          this.load()

        }).catch(() => {})

      }).catch(() => {})

    }

  }

}

</script>



<style scoped>

.code-link { color: #348adb; cursor: pointer; }

</style>

